import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbDataImageFigureEntries } from '../../../models'

export const MB_PRODUCT_DATA_IMAGE_TAB_NORMALIZER = new InjectionToken<Converter<any, MbDataImageFigureEntries>>('MbProductDataImageTabNormalizer')
